// =========================================================================
// 1. TU CÓDIGO ORIGINAL (INTACTO Y BLINDADO PARA LA FICHA DE PRODUCTO)
// =========================================================================
document.addEventListener("DOMContentLoaded", () => {
  
  // 🔥 ESCUDO RADICAL: Solo se ejecuta si la URL contiene "/products/"
  // Esto evita por completo que afecte a la página de inicio, colecciones o cualquier otro lado.
  if (!window.location.pathname.includes('/products/')) {
    return; 
  }

  function inicializarSelectorTallas() {
    // 1. Intentamos buscar el formulario principal de la ficha de producto
    let formulario = document.querySelector('product-form-component[data-section-id*="__main"] form[action*="/cart/add"]');
    
    // Si no lo encuentra (por ejemplo, estamos en el pop-up de compra rápida), buscamos cualquier formulario de carrito activo
    if (!formulario) {
      formulario = document.querySelector('form[action*="/cart/add"]');
    }

    if (!formulario) return;

    // Buscamos el botón real dentro de ese contenedor de compra
    const botonReal = formulario.querySelector('button[name="add"], button[type="submit"]');
    
    // Buscamos el select de tallas (filtrando preferiblemente por la sección principal si existe)
    let select = document.querySelector('variant-picker[data-section-id*="__main"] select[name*="Talla"], variant-picker[data-section-id*="__main"] select[name*="Size"]');
    if (!select) {
      select = document.querySelector('select[name*="Talla"], select[name*="Size"]');
    }

    // 🔥 EL SALVAVIDAS: Si el botón real ya está modificado o NO existe un selector de tallas en este entorno, abortamos.
    if (!botonReal || !select || formulario.querySelector('.fs-custom-trigger-btn')) return;

    const textoOriginalBoton = "AÑADIR A LA CESTA";

    // =========================================
    // INTERFAZ (OVERLAY + PANEL)
    // =========================================
    const overlay = document.createElement("div");
    overlay.className = "fs-overlay";

    const panel = document.createElement("div");
    panel.className = "fs-panel";

    document.body.appendChild(overlay);
    document.body.appendChild(panel);

    let isOpen = false;
    let usuarioYaEligioTalla = false;

    // =========================================
    // NUESTRO BOTÓN CONTROLADOR
    // =========================================
    const botonFlorentino = document.createElement("button");
    botonFlorentino.type = "button";
    botonFlorentino.className = botonReal.className + " fs-custom-trigger-btn";
    botonFlorentino.innerText = textoOriginalBoton;

    botonReal.style.setProperty("display", "none", "important");
    botonReal.parentNode.insertBefore(botonFlorentino, botonReal);

    // =========================================
    // CONSTRUCCIÓN DEL PANEL
    // =========================================
    function construirPanel() {
      let html = `<div class="fs-list">`;

      Array.from(select.options).forEach(option => {
        if (!option.value) return;

        const agotada = option.text.toLowerCase().includes("no disponible") || option.disabled;
        const seleccionada = (usuarioYaEligioTalla && select.value === option.value) ? 'active' : '';

        html += `
          <div class="fs-size ${agotada ? 'disabled' : ''} ${seleccionada}" data-value="${option.value}">
            <span>${option.text}</span>
          </div>
        `;
      });

      const lang = document.documentElement.lang || "es";
      html += `
        <a class="fs-guide" href="${lang.startsWith("en") ? "/en/pages/guia-de-tallas" : "/pages/guia-de-tallas"}">
          ${lang.startsWith("en") ? "Size guide" : "Guía de tallas"}
        </a>
      </div>`;

      panel.innerHTML = html;
    }

    // =========================================
    // CONTROL DE VENTANA (Tapar botón en PC)
    // =========================================
    function abrirPanel() {
      if (isOpen) return;
      isOpen = true;

      construirPanel();

      if (window.innerWidth >= 750) {
        const rect = botonFlorentino.getBoundingClientRect();

        panel.style.position = "absolute"; 
        panel.style.left = rect.left + window.scrollX - 8 + "px";
        panel.style.top = rect.top + window.scrollY - 8 + "px"; // Justo encima
        panel.style.bottom = "auto";
        panel.style.width = botonFlorentino.offsetWidth + 12 + "px";
      } else {
        panel.style.position = "fixed";
        panel.style.left = "0";
        panel.style.top = "auto";
        panel.style.bottom = "0";
        panel.style.width = "100%";
      }

      overlay.classList.add("active");
      panel.classList.add("active");
    }

    function cerrarPanel() {
      isOpen = false;
      overlay.classList.remove("active");
      panel.classList.remove("active");
    }

    function resetearFlujo() {
      usuarioYaEligioTalla = false;
      select.value = "";
      botonFlorentino.innerText = textoOriginalBoton;
    }

    botonFlorentino.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (usuarioYaEligioTalla && select.value !== "") {
        botonReal.click();
        setTimeout(() => { resetearFlujo(); }, 1000);
      } else {
        abrirPanel();
      }
    });

    // =========================================
    // SELECCIÓN DE TALLA Y CIERRE AUTOMÁTICO
    // =========================================
    panel.addEventListener("click", (e) => {
      const sizeItem = e.target.closest(".fs-size");
      if (!sizeItem || sizeItem.classList.contains("disabled")) return;

      const valorTalla = sizeItem.dataset.value;
      const nombreTalla = sizeItem.innerText.replace("—No disponible", "").replace("- No disponible", "").trim();

      select.value = valorTalla;
      select.dispatchEvent(new Event("change", { bubbles: true }));

      usuarioYaEligioTalla = true;

      panel.querySelectorAll(".fs-size").forEach(el => el.classList.remove("active"));
      sizeItem.classList.add("active");
      
      cerrarPanel();

      botonFlorentino.innerText = `CONFIRMAR Y AÑADIR (Talla ${nombreTalla})`;
    });

    overlay.addEventListener("click", cerrarPanel);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") cerrarPanel(); });
    window.addEventListener("resize", () => { if (isOpen) cerrarPanel(); });
  }

  // Ejecución inicial al cargar la página
  inicializarSelectorTallas();

  // El observador ahora es completamente seguro porque está envuelto en el filtro de URL superior
  const observer = new MutationObserver(() => {
    inicializarSelectorTallas();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});


// =========================================================================
// 2. NUEVO BLOQUE EXCLUSIVO E INDEPENDIENTE PARA LA COMPRA RÁPIDA
// =========================================================================
document.addEventListener("DOMContentLoaded", () => {
  // Si estamos dentro de un producto, este bloque secundario no se ejecuta
  if (window.location.pathname.includes('/products/')) return;

  function interceptarCompraRapida() {
    // Buscamos los contenedores que Atelier abre de forma dinámica en las colecciones
    const modalesCompra = document.querySelectorAll('.quick-add-modal, .quick-add-context, .modal__content, quick-add-dialog');

    modalesCompra.forEach(modal => {
      // Si ya adaptamos este modal dinámico, lo ignoramos
      if (modal.dataset.fsModalProcesado === "true" || modal.querySelector('.fs-custom-trigger-btn')) return;

      // Localizamos localmente el select de tallas y el botón dentro del modal abierto
      const selectTallas = modal.querySelector('select[name*="Talla"], select[name*="Size"]');
      const botonReal = modal.querySelector('button[name="add"], button[type="submit"], .quick-add__button-content');

      if (!botonReal || !selectTallas) return;

      // Marcamos el modal como controlado
      modal.dataset.fsModalProcesado = "true";

      const textoBotonOriginal = "AÑADIR A LA CESTA";
      let talleElegido = false;

      // Interfaces locales para el modal
      const overlayLocal = document.createElement("div");
      overlayLocal.className = "fs-overlay";
      const panelLocal = document.createElement("div");
      panelLocal.className = "fs-panel";
      document.body.appendChild(overlayLocal);
      document.body.appendChild(panelLocal);

      // Botón clonado controlador
      const botonFlorentinoRapido = document.createElement("button");
      botonFlorentinoRapido.type = "button";
      botonFlorentinoRapido.className = botonReal.className + " fs-custom-trigger-btn";
      botonFlorentinoRapido.innerText = textoBotonOriginal;

      botonReal.style.setProperty("display", "none", "important");
      botonReal.parentNode.insertBefore(botonFlorentinoRapido, botonReal);

      function renderPanelRapido() {
        let html = `<div class="fs-list">`;
        Array.from(selectTallas.options).forEach(opt => {
          if (!opt.value) return;
          const agotada = opt.text.toLowerCase().includes("no disponible") || opt.disabled;
          const seleccionada = (talleElegido && selectTallas.value === opt.value) ? 'active' : '';
          html += `<div class="fs-size ${agotada ? 'disabled' : ''} ${seleccionada}" data-value="${opt.value}"><span>${opt.text}</span></div>`;
        });
        const lang = document.documentElement.lang || "es";
        html += `<a class="fs-guide" href="${lang.startsWith("en") ? "/en/pages/guia-de-tallas" : "/pages/guia-de-tallas"}">${lang.startsWith("en") ? "Size guide" : "Guía de tallas"}</a></div>`;
        panelLocal.innerHTML = html;
      }

      botonFlorentinoRapido.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (talleElegido && selectTallas.value !== "") {
          botonReal.click();
          setTimeout(() => {
            talleElegido = false;
            selectTallas.value = "";
            botonFlorentinoRapido.innerText = textoBotonOriginal;
          }, 1000);
        } else {
          renderPanelRapido();
          if (window.innerWidth >= 750) {
            const rect = botonFlorentinoRapido.getBoundingClientRect();
            panelLocal.style.position = "absolute";
            panelLocal.style.left = rect.left + window.scrollX + "px";
            panelLocal.style.top = rect.top + window.scrollY + "px";
            panelLocal.style.bottom = "auto";
            panelLocal.style.width = botonFlorentinoRapido.offsetWidth + "px";
          } else {
            panelLocal.style.position = "fixed";
            panelLocal.style.left = "0";
            panelLocal.style.bottom = "0";
            panelLocal.style.top = "auto";
            panelLocal.style.width = "100%";
          }
          overlayLocal.classList.add("active");
          panelLocal.classList.add("active");
        }
      });

      panelLocal.addEventListener("click", (e) => {
        const item = e.target.closest(".fs-size");
        if (!item || item.classList.contains("disabled")) return;

        selectTallas.value = item.dataset.value;
        selectTallas.dispatchEvent(new Event("change", { bubbles: true }));
        talleElegido = true;

        overlayLocal.classList.remove("active");
        panelLocal.classList.remove("active");
        botonFlorentinoRapido.innerText = `CONFIRMAR Y AÑADIR (Talla ${item.innerText.split('-')[0].trim()})`;
      });

      overlayLocal.addEventListener("click", () => {
        overlayLocal.classList.remove("active");
        panelLocal.classList.remove("active");
      });
    });
  }

  // Escuchador dinámico en colecciones para capturar la apertura asíncrona del modal rápido
  const observerRapido = new MutationObserver(() => {
    interceptarCompraRapida();
  });
  observerRapido.observe(document.body, { childList: true, subtree: true });
});